import { Link } from "react-router-dom";
import Logo from "@/components/feature/Logo";

const FRIEND_LINKS = ["影视资讯", "剧集预告", "演员档案", "观影指南", "版权合作"];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-900 mt-16">
      <div className="px-4 md:px-8 py-12 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="mb-4">
              <Logo />
            </div>
            <p className="text-sm text-foreground-700 leading-relaxed max-w-xs">
              桔子TV 专注于电视剧、电影与综艺的在线观看与信息展示，为观众提供清晰便捷的追剧体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4 text-sm tracking-wide">浏览分类</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/category/teleplay" className="text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">电视剧</Link></li>
              <li><Link to="/category/movie" className="text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">电影</Link></li>
              <li><Link to="/category/variety" className="text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">综艺</Link></li>
              <li><Link to="/search" className="text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">搜索影视</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4 text-sm tracking-wide">关于与帮助</h4>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/about" className="text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/about" className="text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">联系方式</Link></li>
              <li><Link to="/about" className="text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">用户反馈</Link></li>
              <li><Link to="/about" className="text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">使用说明</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-950 mb-4 text-sm tracking-wide">友情链接</h4>
            <ul className="space-y-2.5 text-sm">
              {FRIEND_LINKS.map((item) => (
                <li key={item}>
                  <Link to="/about" className="text-foreground-700 hover:text-primary-400 transition-colors cursor-pointer">{item}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © 2026 桔子TV · 本站影视内容仅供信息展示，播放页面为功能演示，不提供真实视频流。
          </p>
          <p className="text-xs text-foreground-600">客服邮箱：support@juzi-tv.example.com</p>
        </div>
      </div>
    </footer>
  );
}